import type { TypedDocumentNode } from '@base-app/web2'
import { gql } from '@base-app/web2'
import type { Video } from './types'

export const CREATE_VIDEO: TypedDocumentNode<
  { createVideo: Video },
  {
    client_id: string
    application_id: string
    playlist_id?: string | null
    name: string
    embedded_link?: string | null
    observations?: string | null
    live?: boolean
    local_live?: boolean
    live_hours?: number | null
    live_timeout?: number | null
    live_secure_url?: string | null
    live_input_uri?: string | null
    live_output_uri?: string | null
    live_public_id?: string | null
  }
> = gql`
  mutation CreateVideo($client_id: ID!, $application_id: ID!, $playlist_id: ID, $name: String!, $embedded_link: String, $observations: String, $live: Boolean, $local_live: Boolean, $live_hours: Int, $live_timeout: Int, $live_secure_url: String, $live_input_uri: String, $live_output_uri: String, $live_public_id: String) {
    createVideo(client_id: $client_id, application_id: $application_id, playlist_id: $playlist_id, name: $name, embedded_link: $embedded_link, observations: $observations, live: $live, local_live: $local_live, live_hours: $live_hours, live_timeout: $live_timeout, live_secure_url: $live_secure_url, live_input_uri: $live_input_uri, live_output_uri: $live_output_uri, live_public_id: $live_public_id) {
      id client_id application_id playlist_id name embedded_link observations live local_live live_hours live_timeout live_secure_url live_input_uri live_output_uri live_public_id synchronized_at created_at updated_at
    }
  }
`

export const UPDATE_VIDEO: TypedDocumentNode<
  { updateVideo: Video },
  {
    id: string
    playlist_id?: string | null
    name?: string
    embedded_link?: string | null
    observations?: string | null
    live?: boolean
    local_live?: boolean
    live_hours?: number | null
    live_timeout?: number | null
    live_secure_url?: string | null
    live_input_uri?: string | null
    live_output_uri?: string | null
    live_public_id?: string | null
  }
> = gql`
  mutation UpdateVideo($id: ID!, $playlist_id: ID, $name: String, $embedded_link: String, $observations: String, $live: Boolean, $local_live: Boolean, $live_hours: Int, $live_timeout: Int, $live_secure_url: String, $live_input_uri: String, $live_output_uri: String, $live_public_id: String) {
    updateVideo(id: $id, playlist_id: $playlist_id, name: $name, embedded_link: $embedded_link, observations: $observations, live: $live, local_live: $local_live, live_hours: $live_hours, live_timeout: $live_timeout, live_secure_url: $live_secure_url, live_input_uri: $live_input_uri, live_output_uri: $live_output_uri, live_public_id: $live_public_id) {
      id client_id application_id playlist_id name embedded_link observations live local_live live_hours live_timeout live_secure_url live_input_uri live_output_uri live_public_id synchronized_at created_at updated_at
    }
  }
`

export const DELETE_VIDEO: TypedDocumentNode<{ deleteVideo: boolean }, { id: string }> = gql`
  mutation DeleteVideo($id: ID!) {
    deleteVideo(id: $id)
  }
`
